<script setup lang="ts">
import { computed } from "vue";

import { toggleActions } from "@/action/toggleActions";
import { action, actionMap } from "@/components/action/action";
import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import { isBacklogBoard } from "@/model/board";
import { useBoardStore } from "@/store/board";
import { useDrawStore } from "@/store/draw";

import AppZoom from "./AppZoom.vue";
import CardZoom from "./CardZoom.vue";

const drawMode = computed(() => useDrawStore().active);
const showStickyActions = computed(() => useBoardStore().creatableStickyTypes.length > 0);
const showCardZoom = computed(
  () =>
    showStickyActions.value &&
    !isBacklogBoard(useBoardStore().currentBoard().type) &&
    !drawMode.value,
);
const isZoomEnabled = computed(() => useBoardStore().isCurrentBoardFluid);
const configureBoardAction = computed(() => useBoardStore().baseBoard.contextActions.board?.draw);

const actions = actionMap(toggleActions);
</script>

<template>
  <TransitionGroup name="slide-right">
    <!-- Sticky Magnify -->
    <IconButton key="magnify" v-bind="actions.toggleStickyMagnify" />

    <!-- Card Zoom -->
    <CardZoom v-if="showCardZoom" />

    <!-- Pointer Trail -->
    <IconButton key="pointer" v-bind="actions.toggleTrailingPointerMode" />

    <!-- Draw Lines -->
    <IconButton
      v-if="showStickyActions && configureBoardAction"
      v-bind="action(configureBoardAction)"
      :activated="drawMode"
    />

    <!-- Pan Mode -->
    <IconButton key="pan" v-bind="actions.togglePanMode" />

    <!-- Zoom -->
    <template v-if="isZoomEnabled">
      <MenuItemDelimiter class="delimiter" />
      <AppZoom />
    </template>
  </TransitionGroup>
</template>
